import userManager from "utils/userManager";
import localForage from "localforage";
import log from "utils/logger";

const logger = log("TokenManager");

class TokenManager {
  static logout() {
    logger.info("Logout clicked");

    userManager.removeUser();

    localStorage.clear();

    const appStore = localForage.createInstance({ name: "app_store" });
    appStore.clear();
  }
}

export default TokenManager;



// WEBPACK FOOTER //
// ./src/accessTokens/TokenManager.js